"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxIconContainer = exports.CheckboxIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CheckIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CheckIcon"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getCheckboxBackgroundColor = function getCheckboxBackgroundColor(props) {
  var theme = props.theme,
      isChecked = props.isChecked;
  return isChecked ? theme.checkedBackgroundColor : theme.backgroundColor;
};

var getCheckboxIconFill = function getCheckboxIconFill(props) {
  var theme = props.theme,
      isChecked = props.isChecked;
  var checkboxIconFillColor = theme.checkboxIconFillColor || theme.backgroundColor;
  return isChecked ? checkboxIconFillColor : 'none';
};

var getCheckboxDash = function getCheckboxDash(isChecked, isIndeterminate, theme) {
  if (isIndeterminate && !isChecked) {
    return "\n      &::before {\n        position: absolute;\n        height: ".concat(theme.checkboxDashHeight, ";\n        width: ").concat(theme.checkboxDashWidth, ";\n        content: '';\n        background: ").concat(theme.accentColor, ";\n        visibility: visible;\n        display: flex;\n      }\n    ");
  }

  return null;
};

var CheckboxIconContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: ", ";\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme,
      hasLabel = _ref.hasLabel;
  return hasLabel && theme.checkboxMargin;
}, function (_ref2) {
  var isChecked = _ref2.isChecked,
      isIndeterminate = _ref2.isIndeterminate,
      theme = _ref2.theme;
  return getCheckboxDash(isChecked, isIndeterminate, theme);
});

exports.CheckboxIconContainer = CheckboxIconContainer;
var CheckboxIcon = (0, _styledComponents["default"])(_CheckIcon["default"])(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: ", ";\n  box-sizing: border-box;\n  fill: ", ";\n  width: ", ";\n  height: ", ";\n  background: ", ";\n  border-radius: ", ";\n  ", "\n"])), function (_ref3) {
  var isDisabled = _ref3.isDisabled;
  return isDisabled ? 'default' : 'pointer';
}, function (props) {
  return getCheckboxIconFill(props);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.checkboxSize;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.checkboxSize;
}, function (props) {
  return getCheckboxBackgroundColor(props);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.checkboxBorderRadius;
}, function (_ref7) {
  var isChecked = _ref7.isChecked,
      theme = _ref7.theme;
  return isChecked ? null : "border: ".concat(theme.checkboxBorder, " solid ").concat(theme.accentColor, ";");
});
exports.CheckboxIcon = CheckboxIcon;